// Fixtures
const basePath = '/assets/images/clubs/';

// ---
export const fixtures = [
  {
    day: 1,
    filePath: `${basePath}Europe/Blank.png`,
  },
  {
    day: 4,
    filePath: `${basePath}Europe/England/West-Ham.png`,
  },
  {
    day: 8,
    filePath: `${basePath}Europe/Blank.png`,
  },
  {
    day: 11,
    filePath: `${basePath}Europe/England/Crystal-Palace.png`,
  },
  {
    day: 16,
    filePath: `${basePath}Europe/England/Aston-Villa.png`,
  },
  {
    day: 25,
    filePath: `${basePath}Europe/England/Brighton.png`,
  },

];
